module.exports = __webpack_public_path__ + "static/media/unchecked.c1966e69.svg";